import { Stack, Typography, useMediaQuery } from '@mui/material'
import { FunctionComponent } from 'react'
import gaiaTheme from '../../../root-components/theme';
import { IColorPalatte } from '../shared-services/public-reports.model';
import { GraphLineChart } from '../../../components/presentation-components/analytics-components/graphs/graph-line-chart';
import { getSeriesConfig } from '../../../shared/interfaces/analytics';
import { usePdfExportMode } from '../../../hooks/use-pdf-export-mode';
import { getGaiaReportBodyTextSx, getGaiaReportSectionShellSx } from './gaia-report-web-page-pdf-styles';
import { useReportContentOverride } from '../shared-services/gaia-report-content';

export const GaiaReportWebPageCompareEmissions: FunctionComponent<{
  companyName: string,
  comparisonDetails: { netEmission: any[], totalEmission: any[]},
  colorPalatte: IColorPalatte
}> = ({ companyName, comparisonDetails, colorPalatte }) => {

  const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const pdfExport = usePdfExportMode();


  const transformedDataset = comparisonDetails.netEmission.map((netItem: any, index: number) => {
    const totalItem = comparisonDetails.totalEmission[index];
    return {
      year: netItem.label,
      totalEmission: totalItem.value,
      netEmission: netItem.value,
    };
  });

  const heading = useReportContentOverride('emissionsOverTime.heading')
  const body = useReportContentOverride('emissionsOverTime.body')

  return (
    <Stack sx={getGaiaReportSectionShellSx({ backgroundColor: colorPalatte.veryLight, pdfExport })}>
      <Typography variant='h3' sx={{ color: colorPalatte.main, mb: 2 }}>{heading ?? 'Emissions Over Time'}</Typography>
      <Typography sx={getGaiaReportBodyTextSx({ color: colorPalatte.dark, isMobileModeMd, isMobileModeSm, pdfExport })}>{body ?? `This chart compares ${companyName}'s total emissions with net emissions over time, helping show how operational changes and offsets have influenced the overall emissions trajectory across reporting periods.`}</Typography>
      <div className="chart-block">
        <GraphLineChart
          title='Total vs Net Emissions Over Time'
          dataset={transformedDataset}
          dataKey='year'
          colors={[colorPalatte.chartSeries[1], colorPalatte.chartSeries[2]]}
          series={getSeriesConfig('netEmission', 'Net Emissions', 'totalEmission', 'Total Emissions')}
          textColor={colorPalatte.dark}
          backgroundColor={'white'}
          />
      </div>
    </Stack >
  )
}